import { actions } from './actions';

export const album = {
  state: {
    albums: {},
    album: {
      title: '圖鑑集載入中...'
    },
  },
  getters: {
    albums(state) {
      return state.albums;
    },
    album(state) {
      return state.album;
    },
  },
  mutations: {
    setAlbums(state, payload) {
      state.albums = payload;
    },
    setAlbum(state, payload) {
      state.album = payload;
    },
  },
  actions,
};